import '@angular/localize/init';
import 'zone.js';

// eslint-disable-next-line no-restricted-globals
(window as any).global = window;
